(() => {
  const stockKey = 'filter.v.availability';
  const collectionSorts = ['created-descending', 'price-ascending', 'price-descending'];
  const searchSorts = ['relevance', 'price-ascending', 'price-descending'];
  function destination(href, name, value, pageType = 'collection') {
    const url = new URL(href);
    const sorts = pageType === 'search' ? searchSorts : collectionSorts;
    if (name === stockKey) {
      if (!['', '0', '1'].includes(value)) return null;
      url.searchParams.delete(stockKey);
      if (value !== '') url.searchParams.set(stockKey, value);
    } else if (name === 'sort_by') {
      if (!sorts.includes(value)) return null;
      url.searchParams.set('sort_by', value);
    } else return null;
    if (pageType === 'search') url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    return url;
  }
  if (typeof module === 'object' && module.exports) module.exports = { destination };
  if (typeof customElements === 'undefined' || customElements.get('corner-browse-controls')) return;
  customElements.define('corner-browse-controls', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        const input = event.target;
        if (!(input instanceof HTMLSelectElement) || input.disabled) return;
        const url = destination(window.location.href, input.name, input.value, this.dataset.pageType);
        if (!url) return;
        const previewEvent = new CustomEvent('corner:browse-change', {
          bubbles: true, cancelable: true, detail: { url: url.href, name: input.name, value: input.value }
        });
        if (!this.dispatchEvent(previewEvent)) return;
        window.location.assign(url.href);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();


(() => {
  if (typeof document === 'undefined') return;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-corner-menu-access]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.href);
    const target = document.getElementById('CornerAccess');
    if (!target || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
    event.preventDefault();
    document.querySelector('.sf-header__mobile .sf-menu-button.active')?.click();
    window.setTimeout(() => {
      const url = new URL(window.location.href);
      url.hash = 'CornerAccess';
      window.history.pushState(window.history.state, '', url.href);
      target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, 350);
  });
})();
